import React, { useState, useEffect } from 'react';

import "./SidebarConfig.css";
import CadastrarUsuario from '../CadastroPerfilUsuario/CadastrarUsuario';
import CadastrarPerfil from '../CadastroPerfilUsuario/CadastrarPerfil';
import PermissionGate from '../CadastroPerfilUsuario/PermissionGate';
import { Button } from 'react-bootstrap';
const SidebarConfig = () => {
  // const handleSelect = (eventKey) => alert(`selected ${eventKey}`);

  const [formularioAtivo, setFormularioAtivo] = useState(() => {
    return localStorage.getItem('formularioAtivo') || '';
  });

  const abrirFormulario = (formulario) => {
    setFormularioAtivo(formulario);
    localStorage.setItem('formularioAtivo', formulario);
    // setShowDropdown(false); // Fecha o dropdown ao abrir um formulário
  };

  useEffect(() => {
    // Atualiza o localStorage sempre que o formulário ativo mudar
    localStorage.setItem('formularioAtivo', formularioAtivo);
  }, [formularioAtivo]);

  // Função para retornar o título com base no formulário ativo
  const obterTitulo = () => {
    switch (formularioAtivo) {
      case 'CadastrarUsuario':
        return 'Cadastrar Usuario';
      case 'CadastrarPerfil': // Novo caso para exibir o título de cadastro de perfil
        return 'Cadastrar Perfil';
      default:
        return '';

    }
  };

  // Função para definir a classe CSS do título com base no formulário ativo
  const obterClasseTitulo = () => {
    switch (formularioAtivo) {
      case 'CadastrarUsuario':
        return 'titulo-cadastro';
      case 'CadastrarPerfil': // Nova classe para título de cadastro de perfil
        return 'titulo-cadastro';
      default:
        return '';

    }
  };
  return (
    <div className="dashboard">
      <div className="sidebar">
        

        {/* Botão Cadastro Usuario */}
        <PermissionGate permissions={["cadastrarUsuarios"]}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => abrirFormulario("CadastrarUsuario")}
            style={{ marginTop: "20px" }}
          >
            Cadastro Usuario
          </Button>
        </PermissionGate>


        {/* Botão Cadastro Perfil */}
        <PermissionGate permissions={["cadastrarUsuarios"]}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => abrirFormulario("CadastrarPerfil")}
            style={{ marginTop: "20px" }}
          >
            Cadastro Perfil
          </Button>
        </PermissionGate>
      </div>

      <div className="content">
        <h1 className={`titulo ${obterClasseTitulo()}`}>{obterTitulo()}</h1>
        {/* Renderiza o formulário ativo */}
        {formularioAtivo === 'CadastrarUsuario' && <CadastrarUsuario />}
        {formularioAtivo === 'CadastrarPerfil' && <CadastrarPerfil />}
      </div>
    </div>
  );
};

export default SidebarConfig;
